import NetworkUtil from "./NetworkUtil";

export class EventAPI{
    public static async getEvents():Promise<{schedMap}>{
        return NetworkUtil.makeGet("/api/events")
    }
}